import { ApiResult, request, safeRequest } from '@synergy/api';

import { SupplierAttributeMappingApi } from '../attribute-mapping/api/supplier-attribute-mapping-api';
import { SupplierCategoryMappingApi } from '../category-mapping/api/supplier-category-mapping-api';
import { SupplierConditionsApi } from '../conditions/api/supplier-conditions-api';
import { SupplierDocumentsApi } from '../documents/api/supplier-detail-documents-api';
import { SupplierEmployeeApi } from '../employees/api/supplier-employees-api';
import { SupplierOverviewApi } from '../overview/api/supplier-detail-overview-api';
import { SupplierUnitMappingApi } from '../unit-mapping/api/supplier-unit-mapping-api';

export class SupplierDetailApi {
    constructor(protected baseUrl: string) {
        this.UnitMapping = new SupplierUnitMappingApi(this.baseUrl);
        this.CategoryMapping = new SupplierCategoryMappingApi(this.baseUrl);
        this.AttributeMapping = new SupplierAttributeMappingApi(this.baseUrl);
        this.Overview = new SupplierOverviewApi(this.baseUrl);
        this.Employees = new SupplierEmployeeApi(this.baseUrl);
        this.Documents = new SupplierDocumentsApi(this.baseUrl);
        this.Conditions = new SupplierConditionsApi(this.baseUrl);
    }

    public UnitMapping: SupplierUnitMappingApi;
    public CategoryMapping: SupplierCategoryMappingApi;
    public AttributeMapping: SupplierAttributeMappingApi;
    public Overview: SupplierOverviewApi;
    public Employees: SupplierEmployeeApi;
    public Documents: SupplierDocumentsApi;
    public Conditions: SupplierConditionsApi;

    public delete(supplierId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/suppliers/${supplierId}`),
            () => null
        );
    }

    public showProducts(supplierId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/suppliers/${supplierId}/show-products`),
            () => null
        );
    }

    public hideProducts(supplierId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/suppliers/${supplierId}/hide-products`),
            () => null
        );
    }

    public lockSupplier(supplierId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/suppliers/${supplierId}/lock`),
            () => null
        );
    }

    public unlockSupplier(supplierId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/suppliers/${supplierId}/unlock`),
            () => null
        );
    }
}
